export enum enumShipmentState {
  QUOTE,
  BOOKED,
  CONFIRMED,
  UPDATED,
  CANCELED,
}
